import {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {OverlayContent} from '~/SignUpSheets/Create/routes/Customize/components/AddMultipleDatesModal/OverlayContent';
import {UPDATE_MULTIPLE_DATES_MODAL} from '~/SignUpSheets/reducers/sheet/constants';
import {initialMultipleDatesModalState} from '~/SignUpSheets/reducers/sheet/reducer';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {BottomSheet} from '~library/molecules/BottomSheet';
import {ResponsiveModal} from '~library/organisms/ResponsiveModal';
import {mediumAndUpQuery} from '~libSass/base/_exports.sass';
import './AddMultipleDatesModal.sass';

export const AddMultipleDatesModal = ({trackChangeUpstream}) => {
  const dispatch = useDispatch();
  const {matches: isDesktop} = useMatchQuery(`(${mediumAndUpQuery})`);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onClickCancel = useCallback(() => {
    dispatch({
      type: UPDATE_MULTIPLE_DATES_MODAL,
      payload: {...initialMultipleDatesModalState, open: false},
    });
  }, []);

  // TODO: We have this class setting in a few places in the SUS Code for modals/bottom sheets;
  // we should consider making this a universal style application for the modal/bottom sheet PB component
  useEffect(() => {
    document.body.classList.add('no-overflow');

    return () => {
      document.body.classList.remove('no-overflow');
    };
  }, []);

  return isDesktop ? (
    <ResponsiveModal
      title="Add multiple dates"
      isOpen
      onClose={onClickCancel}
      className="add-multiple-dates__modal"
      modalId="add-multiple-dates__modal"
      closeOnClickOutside={false}
    >
      <OverlayContent onClose={onClickCancel} trackChangeUpstream={trackChangeUpstream} />
    </ResponsiveModal>
  ) : (
    <BottomSheet
      in
      title="Add multiple dates"
      content={<OverlayContent onClose={onClickCancel} trackChangeUpstream={trackChangeUpstream} />}
      onClose={onClickCancel}
    />
  );
};
